import { render, staticRenderFns } from "./Posts.vue?vue&type=template&id=7dc05413&scoped=true&lang=pug&"
import script from "./Posts.vue?vue&type=script&lang=ts&"
export * from "./Posts.vue?vue&type=script&lang=ts&"
import style0 from "./Posts.vue?vue&type=style&index=0&id=7dc05413&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc05413",
  null
  
)

export default component.exports